import React from "react";
import { PropTypes } from "prop-types";
import { MrbListPage, MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";

function AdminCertifiedModeListTemplate({ adminCertifiedModeListViewStore, t }) {
    const { gridStore, queryUtility } = adminCertifiedModeListViewStore;
    return (
        <MrbListPage store={adminCertifiedModeListViewStore} t={t}>
            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <MrbQuerySearchInput queryUtility={queryUtility} />
            </MrbPageContentHeader>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
            />
        </MrbListPage>
    );
}

AdminCertifiedModeListTemplate.propTypes = {
    adminCertifiedModeListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(AdminCertifiedModeListTemplate);
